import { Link } from 'react-router-dom';
import { Home, Phone } from 'lucide-react';
import { PageLayout } from '@/components/feature/PageLayout';
import { toutesCommunes } from '@/data/communes';

export default function NotFound() {
  const communes = toutesCommunes.slice(0, 10);
  const seo = {
    title: 'Page introuvable',
    description:
      "Cette page n'existe pas ou a été déplacée. Réparation, dépannage et motorisation de volets roulants à Charleroi et dans le Hainaut. Devis gratuit, 0800 20 410.",
    canonicalUrl: '/',
    noindex: true,
  };

  return (
    <PageLayout seo={seo} showDevisForm={false}>
      <section className="py-20 md:py-28 px-4">
        <div className="max-w-2xl mx-auto text-center">
          <p className="text-7xl md:text-8xl font-heading font-extrabold text-primary-500/15 leading-none select-none">
            404
          </p>
          <h1 className="text-2xl md:text-3xl font-heading font-bold text-foreground-700 mt-2">
            Page introuvable
          </h1>
          <p className="mt-4 text-foreground-500 leading-relaxed">
            Désolé, cette page n'existe pas ou a été déplacée. Mais pas d'inquiétude : nous
            réparons vos volets roulants partout à Charleroi et dans le Hainaut.
          </p>

          <div className="mt-8 flex flex-wrap items-center justify-center gap-3">
            <Link
              to="/"
              className="inline-flex items-center gap-2 bg-accent-500 hover:bg-accent-600 text-white px-5 py-3 rounded-xl font-semibold transition-colors"
            >
              <Home className="w-4 h-4" /> Retour à l'accueil
            </Link>
            <a
              href="tel:+3280020410"
              className="inline-flex items-center gap-2 border border-primary-200 text-primary-600 px-5 py-3 rounded-xl font-semibold hover:bg-primary-50 transition-colors"
            >
              <Phone className="w-4 h-4" /> Appeler le 0800 20 410
            </a>
          </div>

          <div className="mt-10">
            <p className="text-sm text-foreground-400 mb-3">Nos zones d'intervention :</p>
            <div className="flex flex-wrap justify-center gap-2">
              {communes.map((c) => (
                <Link
                  key={c.slug}
                  to={c.urlPath}
                  className="text-sm px-3 py-1.5 rounded-full bg-primary-50 text-primary-600 hover:bg-accent-500 hover:text-white transition-colors"
                >
                  {c.nom}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </section>
    </PageLayout>
  );
}
